<template>
  <div style="margin-top: 113px">
    <v-container>
      <v-card>
        <v-card-title>
          <v-col class="d-flex" cols="4"> HR Employees</v-col>
          <v-col class="d-flex" cols="5">
            <v-text-field
              v-model="filter"
              label="Filter on first name or last name"
              @keyup="filterUser($event)"
              @click="filterUser($event)"
            ></v-text-field>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">User</th>
                  <th class="text-left">Strong line manager</th>
                  <th class="text-left">Dotted line manager</th>
                  <th class="text-left">Job title</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in listUsers"
                  :key="item.id"
                  @click="updateEmployee(item)"
                >
                  <td>{{ item.fullName }}</td>
                  <td>{{ item.slm.fullName }}</td>
                  <td>{{ item.dlm.fullName }}</td>
                  <td>{{ item.jobTitle }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<style>
.margin-top {
  margin-top: 10px;
}
.no-margin {
  margin: 0 !important;
}
.card {
  height: 100vh !important;
}
</style>
<script>
export default {
  name: "HRUser",
  data() {
    return {
      listUsers: [],
      filter: "",
      filteredUsers: [],
      originalUsers: [],
    };
  },
  mounted: function() {
    this.loadHRUsers();
  },
  methods: {
    filterUser: function() {
      if (!this.filter || this.filter.length == 0) {
        this.resetFilter();
      } else {
        this.resetFilter();
        this.filteredUsers = [];
        this.listUsers.forEach((user) => {
          if (
            user.firstName.toLowerCase().includes(this.filter.toLowerCase()) ||
            user.lastName.toLowerCase().includes(this.filter.toLowerCase())
          ) {
            this.filteredUsers.push(user);
          }
        });
        this.listUsers = this.filteredUsers;
      }
    },
    resetFilter: function() {
      this.listUsers = this.originalUsers;
    },
    loadHRUsers: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/hrusers", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.message =
              "If your e-mail address is correct and known by the application,";
            this.message +=
              " an e-mail has been sent with insctructions to reset your password";
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          json.data.forEach((element) => {
            element.fullName =
              (element.firstName ? element.firstName : "") +
              " " +
              (element.lastName ? element.lastName : "");
            element.slm.fullName =
              (element.slm.firstName ? element.slm.firstName : "") +
              " " +
              (element.slm.lastName ? element.slm.lastName : "");
            element.dlm.fullName =
              (element.dlm.firstName ? element.dlm.firstName : "") +
              " " +
              (element.dlm.lastName ? element.dlm.lastName : "");
          });
          this.listUsers = json.data;
          this.originalUsers = this.listUsers;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    updateEmployee: function(item) {
      this.$router.push("HRUserUpdate/" + item.id);
    },
  },
};
</script>
